<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novu"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #oblastiGrid
    id="oblastiGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true">
    
    <dxi-column 
      dataField="oblast" 
      caption="Oblast" 
      [minWidth]="300"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novu Oblast"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="oblastForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="oblast"
          placeholder="Unesite naziv oblasti"
          [isValid]="!oblastForm.get('oblast')?.errors"
          validationMessage="Naziv oblasti je obavezan">
        </dx-text-box>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createOblast()"
          [disabled]="!oblastForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>